import { render } from "./PanelAttribute.vue?vue&type=template&id=e44d34a2&scoped=true&ts=true"
import script from "./PanelAttribute.vue?vue&type=script&lang=ts"
export * from "./PanelAttribute.vue?vue&type=script&lang=ts"

import "./PanelAttribute.vue?vue&type=style&index=0&id=e44d34a2&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e44d34a2"]])

export default __exports__